// A conversation's title as the history list shows it.
//
// The title is the first words of the opening question, so it is already in
// whatever language the person wrote it. Two are not: the defaults the server
// writes when there was no question to take them from — 'New conversation'
// (the schema default, data/models.js) and 'Conversation' (AssistantService,
// a conversation opened without a message). Those are English words the
// backend stores (§16) and the list showed them as they came. They are
// repeated here on purpose (§4.1: a constant twice rather than an import
// across the two halves); platform/assistant/tests/conversationTitle.test.js
// keeps the two copies the same.

export const DEFAULT_TITLES = {
  'New conversation': 'assistant.defaultTitles.new',
  Conversation: 'assistant.defaultTitles.untitled',
}

/**
 * @param {{ title?: string }} conversation
 * @param {{ t: Function, te: Function }} i18n  vue-i18n's, from useI18n()
 */
export function conversationTitle(conversation, { t, te }) {
  const title = String(conversation?.title ?? '').trim()
  const key = title ? DEFAULT_TITLES[title] : DEFAULT_TITLES.Conversation
  return key && te(key) ? t(key) : title
}
